import { BlazeError } from '@blaze-cms/core-errors';

function routesHandler() {
  const routes = new Map();

  function get(key) {
    return routes.get(key);
  }

  function getAll() {
    return Array.from(routes.values());
  }

  function add(route) {
    validateRoute(route);

    const { key } = route;
    routes.set(key, route);
  }

  function validateRoute(route) {
    const { key } = route;
    if (!key) throw new BlazeError('Route requires a key');
    if (routes.has(key)) throw new BlazeError(`Route with ${key} has been already added`);
  }

  return { add, get, getAll };
}

export default routesHandler;
